import { memo } from 'react';

import { type BoardAncestors } from '@air/api/types';

export type PublicGalleryBoardAncestorsProps = {
  ancestors: BoardAncestors;
};

export const PublicGalleryBoardAncestors = memo(({ ancestors }: PublicGalleryBoardAncestorsProps) => {
  if (ancestors.length === 0) {
    return null;
  }

  const nearestAncestorTitle = ancestors[ancestors.length - 1].title;

  return <>{ancestors.length > 1 ? `··· / ${nearestAncestorTitle}` : nearestAncestorTitle}</>;
});

PublicGalleryBoardAncestors.displayName = 'PublicGalleryBoardAncestors';
